import { useRecoilValue, useSetRecoilState } from "recoil";
import useAuthPatient from "src/Patient/hooks/useAuthPatient";
import { snackbarState } from "src/store/global/snackbarState";
import { userState } from "src/store/user/userState";

const useCatchErrorApi = () => {

    const setSnackbar = useSetRecoilState(snackbarState);
    const user = useRecoilValue(userState);
    const { handleLogoutUser } = useAuthPatient();

    const catchErrorApi = (error) => {
        let message = "Estamos teniendo inconvenientes, por favor intente nuevamente";
        let severity = "error";

        if(error?.response?.status === 401 && user.isAuthenticated === true) {
            message = "Su sesión de usuario ha caducado";
            severity = "info";

            setTimeout(() => {
                handleLogoutUser();
            }, 2000)
        }

        if(error.message && error.message === 'Network Error') {
            message = "Ha ocurrido un error de red, por favor verifique su conexión a internet";
        }

        if (error?.response?.data) {
            message = error.response.data.errors[0].message;
            //console.log("snackbar MSJ ERROR : ", message);            
            //setTimeout( () => window.location.reload(false) , 1000 );
        }

        if(!error.hasOwnProperty('dataErrors')) {
            setSnackbar({
                openAlert: true,
                severity: severity,
                text: message,
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });
        }

    }

    return {
        catchErrorApi
    }
}

export default useCatchErrorApi;